import React, { useEffect, useState } from 'react';
import External from './External'
import Internal from './Internal'
import VisualField from './VisualField'
import Tonometry from '../../../../../itrust_common/components/authorised/examFormPartial/internalExtenalTests/Tonometry';

let ExternalInternalTests = props => {
  const { fieldsValues: {
    external_attributes,
    internal_attributes,
    nct = [],
    gat = [],
    tonometry = [],
    visual_field,
  },
    template,
    isPdfView,
    store } = props;

  let [gatShowLabel, gatSetstate] = useState()
  let [nctShowLabel, nctSetstate] = useState()
  let [tonometryShowLabel, tonometrySetstate] = useState()

  useEffect(() => {
    gatSetstate(gat?.some(test => test.is_marked_complete));
    nctSetstate(nct?.some(test => test.is_marked_complete));
    tonometrySetstate(tonometry?.some(test => test.is_marked_complete));
    gatSetstate(gatShowLabel)
    nctSetstate(nctShowLabel)
  }, [gat, nct, tonometry]);

  return (
    <div className="row">
      {external_attributes && external_attributes.is_marked_complete &&
        <div className="col-12">
          <div className="border-bottom">
            <h6 className="pb-3 pt-6">{template.external_exam.custom_label}</h6>
          </div>
          <External isPdfView={isPdfView} fieldsValues={external_attributes} template={template?.external_exam} />
        </div>
      }
      {template?.tonometry?.visible === 'true' &&
        tonometry?.length > 0 &&
        tonometryShowLabel && (
          <div className="col-3">
            <h6 className="pb-3 pt-6">{template.tonometry.custom_label}</h6>
            <Tonometry
              fieldsValues={tonometry}
              template={template.tonometry}
            />
          </div>
        )}

      {visual_field && <div className="col-3">
        <h6 className="pb-3 pt-6">{template.visual_field.custom_label}</h6>
        <VisualField fieldsValues={visual_field} template={template.visual_field} />
      </div>}

      {internal_attributes && internal_attributes.is_marked_complete &&
        <div className="col-12">
          <div className="border-bottom">
            <h6 className="pb-3 pt-6">{template.internal_exam.custom_label}</h6>
          </div>
          <Internal isPdfView={isPdfView} fieldsValues={internal_attributes} template={template.internal_exam} store={store} />
        </div>
      }
    </div>
  )
}


export default ExternalInternalTests;
